<template>
  <div>
    <div class="input-full">
      <div>
        <div class="card-content padding">
          <div v-if="!isFormReady" class="form-loading-state">
            <div class="preloader-card">
              <f7-preloader />
              <div class="preloader-text">
                {{ $t('loading') }}
              </div>
            </div>
          </div>
          <div v-show="isFormReady" class="form-container">
            <div
              v-if="isLoadingSelectorsOverlay"
              class="form-loading-overlay"
            >
              <div class="preloader-card">
                <f7-preloader />
                <div class="preloader-text">
                  {{ $t('loading') }}
                </div>
              </div>
            </div>
            <form>
              <DxForm
                ref="splRegisterForm"
                label-location="top"
                :col-count="10"
                :form-data="formData"
              >
                <!-- Primera fila -->
                <DxGroupItem :col-count="12" :col-span="10">
                  <DxItem
                    data-field="CodPresupuesto"
                    editor-type="dxSelectBox"
                    :col-span="2"
                    :editor-options="{
                      disabled: isTempSampleEditLocked,
                      dataSource: normalizedBudgetOptions,
                      displayExpr: 'CodOfferTitle',
                      valueExpr: 'CodPresupuesto',
                      searchEnabled: true,
                      showClearButton: false,
                    }"
                  >
                    <DxLabel :text="$t('samplesRegister.budget')" />
                  </DxItem>

                  <DxItem
                    editor-type="dxDateBox"
                    data-field="FechaMuestreo"
                    :col-span="2"
                    :editor-options="{
                      type: 'datetime',
                      displayFormat:
                        $helpers.getDateFormat(company) + ' HH:mm',
                      disabled: false,
                      elementAttr: {
                        class: 'samples-register-datetime-field',
                      },
                      dropDownOptions: {
                        wrapperAttr: {
                          class: 'samples-register-datetime-popup',
                        },
                      },
                      elementAttr: {
                        class: 'samples-register-datetime-field',
                      },
                      dropDownOptions: {
                        wrapperAttr: {
                          class: 'samples-register-datetime-popup',
                        },
                      },
                    }"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.samplingDateTime')"
                    />
                  </DxItem>
                  <DxItem
                    editor-type="dxTextBox"
                    data-field="MuestreadorLiteral"
                    :col-span="2"
                    :editor-options="{ disabled: false }"
                  >
                    <DxLabel :text="$t('samplesRegister.sampler')" />
                  </DxItem>
                  <DxItem
                    data-field="idFamiliaTM"
                    editor-type="dxSelectBox"
                    :col-span="2"
                    :editor-options="{
                      disabled:
                        familiDisabled ||
                        isFamilyLockedByShippingDate ||
                        isTempSampleEditLocked,
                      dataSource: {
                        store: familiesFiltered,
                        sort: { selector: 'FamiliaTM', desc: false },
                      },
                      displayExpr: 'FamiliaTM',
                      valueExpr: 'idFamiliaTM',
                      searchEnabled: true,
                    }"
                  >
                    <DxLabel :text="$t('samplesRegister.family')" />
                  </DxItem>

                  <DxItem
                    data-field="IdTipoMuestra"
                    editor-type="dxSelectBox"
                    :col-span="2"
                    :editor-options="{
                      disabled:
                        sampleTypesDisabled ||
                        isTempSampleEditLocked,
                      dataSource: {
                        store: normalizedSampletypesUi,
                        sort: {
                          selector: 'Descripcion',
                          desc: false,
                        },
                      },
                      displayExpr: 'Descripcion',
                      valueExpr: 'idTipoMuestra',
                      searchEnabled: true,
                    }"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.sampleType')"
                    />
                  </DxItem>
                  <DxItem
                    data-field="IdSubTipoMuestra"
                    editor-type="dxSelectBox"
                    :col-span="2"
                    :editor-options="{
                      disabled: subSampleTypeVisible,
                      dataSource: {
                        store: normalizedSubSampleType,
                        sort: {
                          selector: 'Descripcion',
                          desc: false,
                        },
                      },
                      displayExpr: 'Descripcion',
                      valueExpr: 'idSubTipoMuestra',
                      searchEnabled: true,
                    }"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.sampleSubtype')"
                    />
                  </DxItem>
                </DxGroupItem>

                <DxGroupItem :col-count="4" :col-span="10">
                  <DxItem
                    editor-type="dxNumberBox"
                    data-field="cloroResidual"
                    :editor-options="{
                      min: 0,
                      max: 10,
                      step: 0.1,
                      format: '#0.0',
                      showSpinButtons: true,
                      disabled: false,
                      visible: chlorineVisible,
                    }"
                    :visible="chlorineVisible"
                    :col-span="1"
                  >
                    <DxLabel
                      :text="
                        $t('samplesRegister.freeResidualChlorine')
                      "
                      :visible="chlorineVisible"
                    />
                  </DxItem>
                  <DxItem
                    editor-type="dxSelectBox"
                    data-field="CodArticulo"
                    :editor-options="{
                      disabled:
                        analysisTypeDisabled ||
                        isTempSampleEditLocked,
                      dataSource: articlesBySubFamilia,
                      searchEnabled: true,
                      displayExpr: 'AtDescrip',
                      valueExpr: 'CodArticulo',
                      showClearButton: false,
                    }"
                    :col-span="chlorineVisible ? 2 : 3"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.analysisType')"
                    />
                  </DxItem>
                  <DxItem
                    editor-type="dxTextBox"
                    data-field="Lote"
                    :col-span="1"
                    :editor-options="{
                      disabled: false,
                      maxLength: isTempSampleEditLocked
                        ? 50
                        : undefined,
                    }"
                  >
                    <DxLabel :text="$t('samplesRegister.lot')" />
                  </DxItem>
                </DxGroupItem>
                <DxGroupItem :col-count="1" :col-span="10">
                  <DxItem
                    editor-type="dxTextBox"
                    data-field="SampleDescription"
                    :editor-options="{ disabled: false, height: 50 }"
                    :col-span="3"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.sampleDescription')"
                    />
                  </DxItem>
                </DxGroupItem>
                <DxGroupItem :col-count="5" :col-span="10">
                  <DxItem
                    editor-type="dxCheckBox"
                    data-field="cma"
                    :editor-options="{
                      disabled: false,
                      visible: checkCma,
                    }"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.cmaEnabled')"
                      :visible="checkCma"
                      location="left"
                    />
                  </DxItem>

                  <DxItem
                    editor-type="dxSelectBox"
                    data-field="Legislacion"
                    :editor-options="{
                      disabled: false,
                      dataSource: legislations,
                      displayExpr: 'Legislacion',
                      valueExpr: 'idLegislacion',
                      visible: legislationVisible,
                    }"
                    :col-span="4"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.legislation')"
                      :visible="legislationVisible"
                    />
                  </DxItem>
                </DxGroupItem>
                <DxGroupItem :col-count="8" :col-span="10">
                  <DxItem
                    editor-type="dxCheckBox"
                    data-field="automaticSamplingPoint"
                    :col-span="2"
                    :editor-options="{
                      disabled: false,
                      visible: true,
                    }"
                  >
                    <DxLabel
                      :text="
                        $t('samplesRegister.automaticSamplingPoint')
                      "
                      :visible="true"
                      location="left"
                    />
                  </DxItem>

                  <DxItem
                    v-if="formData.automaticSamplingPoint"
                    editor-type="dxSelectBox"
                    data-field="Parcelas"
                    :editor-options="{
                      disabled: false,
                      dataSource: normalizedFarms,
                      displayExpr: 'Finca',
                      valueExpr: 'idFinca',
                    }"
                    :col-span="2"
                  >
                    <DxLabel :text="$t('samplesRegister.farm')" />
                  </DxItem>

                  <DxItem
                    v-else
                    editor-type="dxTextBox"
                    data-field="FincaLiteral"
                    :editor-options="{
                      disabled: false,
                    }"
                    :col-span="2"
                  >
                    <DxLabel :text="$t('samplesRegister.farm')" />
                  </DxItem>

                  <DxItem
                    v-if="formData.automaticSamplingPoint"
                    editor-type="dxSelectBox"
                    data-field="Parcela"
                    :editor-options="{
                      disabled: parcelaDisabled,
                      dataSource: filteredParcels,
                      displayExpr: 'Parcela',
                      valueExpr: 'idParcela',
                    }"
                    :col-span="2"
                  >
                    <DxLabel :text="$t('samplesRegister.plot')" />
                  </DxItem>

                  <DxItem
                    v-else
                    editor-type="dxTextBox"
                    data-field="ParcelaLiteral"
                    :editor-options="{
                      disabled: false,
                    }"
                    :col-span="2"
                  >
                    <DxLabel :text="$t('samplesRegister.plot')" />
                  </DxItem>

                  <DxItem
                    v-if="formData.automaticSamplingPoint"
                    data-field="idNivelPunto"
                    editor-type="dxSelectBox"
                    :editor-options="{
                      disabled: !isLevelPointSelectionEnabled,
                      dataSource: filteredLevelPoints,
                      displayExpr: getLevelPointOptionText,
                      valueExpr: 'idNivelPunto',
                      searchEnabled: true,
                      placeholder: getLevelPointPlaceholder(),
                      showDropDownButton:
                        isLevelPointSelectionEnabled,
                      onValueChanged: handleLevelPointChange,
                    }"
                    :col-span="2"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.pointCoordinate')"
                    />
                  </DxItem>
                </DxGroupItem>

                <DxGroupItem :col-count="5" :col-span="10">
                  <DxItem
                    editor-type="dxCheckBox"
                    data-field="lmr"
                    :editor-options="{
                      disabled: isTempSampleEditLocked,
                      visible: checkLmr,
                    }"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.lmrEnabled')"
                      :visible="checkLmr"
                      location="left"
                    />
                  </DxItem>

                  <DxItem
                    editor-type="dxCheckBox"
                    data-field="trazaCultivo"
                    :editor-options="{
                      disabled: isTempSampleEditLocked,
                      visible: traceCultiveVisible,
                    }"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.trace')"
                      :visible="traceCultiveVisible"
                      location="left"
                    />
                  </DxItem>

                  <DxItem
                    editor-type="dxCheckBox"
                    data-field="organicFarming"
                    :editor-options="{
                      disabled: isTempSampleEditLocked,
                      visible: traceCultiveVisible,
                    }"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.organicFarming')"
                      :visible="traceCultiveVisible"
                      location="left"
                    />
                  </DxItem>
                </DxGroupItem>
                <DxGroupItem :col-count="10" :col-span="10">
                  <DxItem
                    editor-type="dxTextBox"
                    :editor-options="{
                      disabled: true,
                      value: 'UE',
                      visible: paisesLMR,
                    }"
                  >
                    <DxLabel text="País 1" :visible="paisesLMR" />
                  </DxItem>
                  <DxItem
                    editor-type="dxTextBox"
                    :editor-options="{
                      disabled: true,
                      value: 'US',
                      visible: paisesLMR,
                    }"
                  >
                    <DxLabel text="País 2" :visible="paisesLMR" />
                  </DxItem>
                  <DxItem
                    editor-type="dxTextBox"
                    :editor-options="{
                      disabled: true,
                      value: 'RU',
                      visible: paisesLMR,
                    }"
                  >
                    <DxLabel text="País 3" :visible="paisesLMR" />
                  </DxItem>
                  <DxItem
                    editor-type="dxTextBox"
                    :editor-options="{
                      disabled: true,
                      value: 'JP',
                      visible: paisesLMR,
                    }"
                  >
                    <DxLabel text="País 4" :visible="paisesLMR" />
                  </DxItem>
                  <DxItem
                    editor-type="dxTextBox"
                    :editor-options="{
                      disabled: true,
                      value: 'CX',
                      visible: paisesLMR,
                    }"
                  >
                    <DxLabel text="País 5" :visible="paisesLMR" />
                  </DxItem>
                  <DxItem
                    editor-type="dxTextBox"
                    :editor-options="{
                      disabled: true,
                      visible: paisesLMR,
                    }"
                  >
                    <DxLabel text="País 6" :visible="paisesLMR" />
                  </DxItem>
                  <DxItem
                    editor-type="dxTextBox"
                    :editor-options="{
                      disabled: true,
                      visible: paisesLMR,
                    }"
                  >
                    <DxLabel text="País 7" :visible="paisesLMR" />
                  </DxItem>
                  <DxItem
                    editor-type="dxTextBox"
                    :editor-options="{
                      disabled: true,
                      visible: paisesLMR,
                    }"
                  >
                    <DxLabel text="País 8" :visible="paisesLMR" />
                  </DxItem>
                  <DxItem
                    editor-type="dxTextBox"
                    :editor-options="{
                      disabled: true,
                      visible: paisesLMR,
                    }"
                  >
                    <DxLabel text="País 9" :visible="paisesLMR" />
                  </DxItem>
                  <DxItem
                    editor-type="dxTextBox"
                    :editor-options="{
                      disabled: true,
                      visible: paisesLMR,
                    }"
                  >
                    <DxLabel text="País 10" :visible="paisesLMR" />
                  </DxItem>
                </DxGroupItem>
                <DxItem
                  data-field="Observaciones"
                  editor-type="dxTextArea"
                  :editor-options="{
                    disabled: false,
                    height: 50,
                    maxLength: 2000,
                  }"
                  :col-span="10"
                >
                  <DxLabel
                    :text="$t('samplesRegister.sampleObservations')"
                  />
                </DxItem>
              </DxForm>
              <div
                v-if="
                  sampleSummary.code ||
                  sampleSummary.analysis ||
                  sampleSummary.price
                "
                class="sample-summary-row"
              >
                <div class="sample-summary-code">
                  {{ sampleSummary.code }}
                </div>
                <div class="sample-summary-analysis">
                  {{ sampleSummary.analysis }}
                </div>
                <div class="sample-summary-price">
                  {{ sampleSummary.price }}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  DxForm,
  DxItem,
  DxLabel,
  DxGroupItem,
} from 'devextreme-vue/form';
import { mapActions, mapGetters, mapState } from 'vuex';
import {
  NOTIFY_TIME_LONG,
  ENABLE_TEMP_SAMPLE_EDIT_LOCK,
} from '@/js/constants';
import helpers from '@/js/helpers';
import EventBus from '@/services/event-bus';

export default {
  components: {
    DxForm,
    DxItem,
    DxLabel,
    DxGroupItem,
  },
  props: {
    store: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formData: {
        CodCliente: null,
        idAlbaran: null,
        CodPresupuesto: this.store?.CodPresupuesto || null,
        FamiliaTM: null,
        Descripcion: null,
        Articulo: null,
        cma: null,
        lmr: null,
        trazaCultivo: false,
        Legislacion: null,
        automaticSamplingPoint: false,
        Parcelas: null,
        Parcela: null,
        FincaLiteral: null,
        ParcelaLiteral: null,
        idNivelPunto: null,
        NivelPuntoCoordLiteral: null,
        SubTipoMuestra: null,
        SampleDescription: null,
        FechaMuestreo: null,
        Lote: null,
        MuestreadorLiteral: null,
        organicFarming: false,
        Observaciones: null,
        cloroResidual: null,
        IdWMuestra: null,
        CodMuestra: null,
        Pedido: null,
        CodLinea: null,
        CodArticulo: null,
        PrecioAT: null,
        IdAnalisisTipo: null,
        idPresupuestoATNoS: null,
        IdPresupuestoATNoS: null,
        idFamiliaTM: null,
        idSubFamiliaTM: null,
        IdTipoMuestra: null,
        IdSubTipoMuestra: null,
        idLegislacion: null,
      },
      paisesLMR: false,
      familiDisabled: false,
      sampleTypesDisabled: false,
      subSampleTypeVisible: true,
      analysisTypeDisabled: false,
      traceCultiveVisible: true,
      legislationVisible: false,
      chlorineVisible: false,
      samplingPointVisible: true,
      automaticSamplingPointValue: false,
      analysisType: [],
      familiesFiltered: [],
      offersFamiliesFiltered: [],
      subFamiliesFiltered: [],
      subSampleType: [],
      filteredParcels: [],
      filteredLevelPoints: [],
      typebox: 'dxTextBox',
      fincaDisabled: true,
      parcelaDisabled: true,
      idLegislacion: '',
      idSubFamiliaTiposMuestras: null,
      traceValue: false,
      cultiveValue: false,
      checkCma: false,
      checkLmr: false,
      farmsLoaded: false,
      isFormReady: false,
      isHydratingSelectors: false,
      isRehydratingSamplingPoint: false,
      isLoadingBudgetOptions: false,
      isLoadingSampleTypes: false,
      sampletypesUi: [],
      isRevertingBudgetSelection: false,
      revertingBudgetContext: null,
    };
  },
  computed: {
    // TEMP_BLOQUEO_EDITAR_MUESTRA
    isTempSampleEditLocked() {
      return ENABLE_TEMP_SAMPLE_EDIT_LOCK;
    },
    isLoadingSelectorsOverlay() {
      return this.isLoadingBudgetOptions || this.isLoadingSampleTypes;
    },
    budgetOptions() {
      const budgets = Array.isArray(this.presupuestos)
        ? [...this.presupuestos]
        : [];
      const currentBudgetCode =
        this.formData.CodPresupuesto || this.store?.CodPresupuesto;

      const hasCurrentBudget = budgets.some(
        (item) => item?.CodPresupuesto === currentBudgetCode
      );

      if (currentBudgetCode && !hasCurrentBudget) {
        budgets.unshift({
          CodPresupuesto: currentBudgetCode,
          CodOfferTitle:
            this.store?.CodOfferTitle || currentBudgetCode,
        });
      }

      return budgets;
    },
    normalizedBudgetOptions() {
      return (this.budgetOptions || []).map((item) => ({
        ...item,
        CodPresupuesto: item?.CodPresupuesto ?? null,
        CodOfferTitle:
          item?.CodOfferTitle ||
          `${item?.CodPresupuesto || ''}${
            item?.Titulo ? ` - ${item.Titulo}` : ''
          }${
            item?.CodEstado === '1'
              ? ` (${this.$t(
                  this.$helpers.getStatusTextKey(item.Estado)
                )})`
              : ''
          }`,
      }));
    },
    normalizedSampletypesUi() {
      return (this.sampletypesUi || []).map((item) => ({
        ...item,
        idTipoMuestra: this.normalizeSelectionId(item.idTipoMuestra),
        idSubFamiliaTM: this.normalizeSelectionId(
          item.idSubFamiliaTM ?? item.id_sub_familia
        ),
        id_sub_familia: this.normalizeSelectionId(
          item.id_sub_familia ?? item.idSubFamiliaTM
        ),
      }));
    },
    normalizedSubSampleType() {
      return (this.subSampleType || []).map((item) => ({
        ...item,
        idSubTipoMuestra: this.normalizeSelectionId(
          item.idSubTipoMuestra
        ),
      }));
    },
    isLevelPointSelectionEnabled() {
      return (
        this.formData.automaticSamplingPoint &&
        this.formData.Parcela != null &&
        this.filteredLevelPoints.length > 0
      );
    },
    articlesBySubFamilia() {
      const id = this.idSubFamiliaTiposMuestras;
      if (id == null) return [];
      const idNum = Number(id);
      if (Number.isNaN(idNum)) return [];
      return this.analysisType.filter((a) => {
        const sub =
          a.IdSubFamilia != null ? a.IdSubFamilia : a.IdSubFamiliaTM;
        return Number(sub) === idNum;
      });
    },
    selectedAnalysisType() {
      return (
        this.analysisType.find(
          (item) => item.CodArticulo === this.formData.CodArticulo
        ) || null
      );
    },
    sampleSummary() {
      return {
        code:
          this.formData.CodMuestra || this.store?.CodMuestra || '',
        analysis: this.buildAnalysisDisplayText(
          this.selectedAnalysisType,
          this.formData.Articulo ||
            this.store?.AtDescrip ||
            this.store?.AnalisisTipo ||
            ''
        ),
        price: this.formatPrice(
          this.formData.PrecioAT ?? this.store?.PrecioAT
        ),
      };
    },
    ...mapState('contact', ['company']),
    ...mapGetters('contact', ['contactInfo']),
    ...mapState('Offers', [
      'presupuestos',
      'detallesPresupuestos',
      'analisisTipoDescrip',
    ]),
    ...mapState('samplesRegisterModule', [
      'sampletypes',
      'families',
      'offerSelected',
      'legislations',
      'farmsWithParcels',
      'invoiceDetails',
    ]),
    normalizedFarms() {
      return (this.farmsWithParcels || []).map((farm) => {
        const normIdFinca = this.normalizeSelectionId(farm.idFinca);
        const normParcels = (farm.Parcelas || []).map((p) => ({
          ...p,
          idParcela: this.normalizeSelectionId(p.idParcela),
        }));
        return {
          ...farm,
          idFinca: normIdFinca,
          Parcelas: normParcels,
        };
      });
    },
    shippingDateReference() {
      return (
        this.invoiceDetails?.FechaRecogidaDate ||
        this.invoiceDetails?.FechaRecogida ||
        null
      );
    },
    isShippingDateInFuture() {
      const shippingDate = this.normalizeDateOnly(
        this.shippingDateReference
      );
      const today = this.normalizeDateOnly(new Date());

      if (!shippingDate || !today) {
        return false;
      }

      return shippingDate.getTime() > today.getTime();
    },
    isFamilyLockedByShippingDate() {
      const shippingDate = this.normalizeDateOnly(
        this.shippingDateReference
      );
      const today = this.normalizeDateOnly(new Date());

      if (!shippingDate || !today) {
        return false;
      }

      return shippingDate.getTime() <= today.getTime();
    },
  },
  watch: {
    'formData.CodPresupuesto': async function (
      nuevoValor,
      valorAnterior
    ) {
      if (this.isRevertingBudgetSelection) {
        this.isRevertingBudgetSelection = false;
        const revertContext = this.revertingBudgetContext;
        this.revertingBudgetContext = null;
        await this.handleBudgetChange(nuevoValor, {
          preserveValues: true,
          previousBudgetCode:
            revertContext?.previousBudgetCode ?? valorAnterior,
          forcedSelections: revertContext?.previousSelections ?? null,
        });
        return;
      }
      if (this.isHydratingSelectors) return;
      if (nuevoValor === valorAnterior) return;
      await this.handleBudgetChange(nuevoValor, {
        previousBudgetCode: valorAnterior,
      });
    },
    'formData.idFamiliaTM': async function (idFamilia) {
      if (this.isHydratingSelectors) return;
      await this.handleFamilyChange(idFamilia);
    },
    'formData.IdTipoMuestra': async function (idTipoMuestra) {
      if (this.isHydratingSelectors) return;
      await this.handleSampleTypeChange(idTipoMuestra);
    },
    'formData.IdSubTipoMuestra': function (idSubTipoMuestra) {
      if (this.isHydratingSelectors) return;
      this.handleSubSampleTypeChange(idSubTipoMuestra);
    },
    'formData.CodArticulo': async function (codArticulo) {
      if (this.isHydratingSelectors) return;
      await this.handleArticleChange(codArticulo);
    },
    'formData.Legislacion': function (value) {
      this.formData.idLegislacion = value;
    },
    'formData.automaticSamplingPoint': async function (value) {
      this.updateParcelasEditorType(value);
      if (!value) {
        this.filteredParcels = [];
        this.filteredLevelPoints = [];
        this.parcelaDisabled = false;
        this.formData.idNivelPunto = null;
        if (this.isHydratingSelectors) {
          // When opening an existing sample in manual mode, restore the
          // literals already loaded from backend/store.
          this.formData.Parcelas = this.formData.FincaLiteral || null;
          this.formData.Parcela =
            this.formData.ParcelaLiteral || null;
          this.formData.NivelPuntoCoordLiteral =
            this.formData.NivelPuntoCoordLiteral ||
            this.store?.NivelPuntoCoordLiteral ||
            this.store?.nivelPuntoCoordLiteral ||
            null;
        } else {
          // When the user manually disables automatic sampling, reset the
          // selector-based values and expose empty free-text inputs.
          this.formData.Parcelas = null;
          this.formData.Parcela = null;
          this.formData.FincaLiteral = null;
          this.formData.ParcelaLiteral = null;
          this.formData.NivelPuntoCoordLiteral = null;
        }
        return;
      }

      this.parcelaDisabled = this.parcelaDisabled;
    },
    'formData.Parcelas': async function (idFinca) {
      if (!this.formData.automaticSamplingPoint) {
        this.formData.FincaLiteral = idFinca || null;
        return;
      }

      const normalizedIdFinca = this.normalizeSelectionId(idFinca);
      if (normalizedIdFinca != null) {
        const farm = this.findFarmById(normalizedIdFinca);
        this.filteredParcels = farm?.Parcelas
          ? [...farm.Parcelas]
          : [];
        this.filteredLevelPoints = [];
        this.formData.FincaLiteral = farm?.Finca || null;
        if (!this.isHydratingSelectors) {
          this.formData.Parcela = null;
          this.formData.ParcelaLiteral = null;
          this.formData.idNivelPunto = null;
          this.formData.NivelPuntoCoordLiteral = null;
        }
        this.parcelaDisabled = false;
      } else {
        this.filteredParcels = [];
        this.filteredLevelPoints = [];
        this.formData.FincaLiteral = null;
        this.formData.Parcela = null;
        this.formData.ParcelaLiteral = null;
        this.formData.idNivelPunto = null;
        this.parcelaDisabled = true;
      }
    },
    'formData.Parcela': async function (idParcela) {
      if (!this.formData.automaticSamplingPoint) {
        this.formData.ParcelaLiteral = idParcela || null;
        this.filteredLevelPoints = [];
        this.formData.idNivelPunto = null;
        return;
      }

      const normalizedIdParcela =
        this.normalizeSelectionId(idParcela);
      if (normalizedIdParcela != null) {
        const parcela = this.findParcelById(normalizedIdParcela);
        this.formData.ParcelaLiteral = parcela?.Parcela || null;
        this.filteredLevelPoints = Array.isArray(parcela?.nivelPuntos)
          ? [...parcela.nivelPuntos]
          : [];
        if (
          !this.isHydratingSelectors &&
          !this.isRehydratingSamplingPoint
        ) {
          this.formData.idNivelPunto = null;
          this.formData.NivelPuntoCoordLiteral = null;
        } else if (this.formData.idNivelPunto != null) {
          const selectedPoint = this.filteredLevelPoints.find(
            (item) =>
              this.normalizeSelectionId(item?.idNivelPunto) ===
              this.normalizeSelectionId(this.formData.idNivelPunto)
          );
          this.formData.NivelPuntoCoordLiteral = selectedPoint
            ? this.getLevelPointOptionText(selectedPoint)
            : this.formData.NivelPuntoCoordLiteral || null;
        }
      } else {
        this.formData.ParcelaLiteral = null;
        this.filteredLevelPoints = [];
        this.formData.idNivelPunto = null;
        this.formData.NivelPuntoCoordLiteral = null;
      }
    },
    farmsWithParcels: {
      handler() {
        this.syncFarmAndParcelState();
        if (
          this.formData.automaticSamplingPoint &&
          (this.formData.Parcelas || this.formData.Parcela) &&
          (this.farmsWithParcels || []).length
        ) {
          // re-asignar valores una vez llega el dataSource para que DevExtreme seleccione
          this.formData.Parcelas = this.normalizeSelectionId(
            this.formData.Parcelas
          );
          this.formData.Parcela = this.normalizeSelectionId(
            this.formData.Parcela
          );
          this.$nextTick(() => {
            this.updateParcelasEditorType(
              this.formData.automaticSamplingPoint
            );
          });
        }
      },
      deep: true,
    },
    formData: {
      handler(nuevoFormData) {
        EventBus.$emit('formData2', nuevoFormData);
      },
      deep: true,
    },
  },
  async beforeMount() {
    this.isFormReady = false;
    this.isHydratingSelectors = true;
    if (!this.presupuestos?.length) {
      await this.fetchPresupuestos({
        isOnlineRegister: true,
      }).catch((error) => {
        console.log(
          '[SamplesRegisteredDetails] error fetchPresupuestos',
          error
        );
      });
    }
    if (this.store) {
      const mapping = {
        CodCliente: 'CodCliente',
        idAlbaran: 'idAlbaran',
        CodPresupuesto: 'CodPresupuesto',
        FamiliaTM: 'FamiliaTM',
        TipoMuestra: 'Descripcion',
        SubTipoMuestra: 'SubTipoMuestra',
        Muestra: 'SampleDescription',
        AnalisisTipo: 'Articulo',
        FechaMuestreo: 'FechaMuestreo',
        LoteCodigo: 'Lote',
        MuestreadorLiteral: 'MuestreadorLiteral',
        ProduccionOrganica: 'organicFarming',
        CloroResidualLibre: 'cloroResidual',
        IdWMuestra: 'IdWMuestra',
        CodMuestra: 'CodMuestra',
        Pedido: 'Pedido',
        CodLinea: 'CodLinea',
        CodArticulo: 'CodArticulo',
        IdAnalisisTipo: 'IdAnalisisTipo',
        idPresupuestoATNoS: 'idPresupuestoATNoS',
        IdPresupuestoATNoS: 'IdPresupuestoATNoS',
        idFamiliaTM: 'idFamiliaTM',
        idSubFamiliaTM: 'idSubFamiliaTM',
        IdTipoMuestra: 'IdTipoMuestra',
        IdSubTipoMuestra: 'IdSubTipoMuestra',
        idLegislacion: 'idLegislacion',
        ObservacionesMuestra: 'Observaciones',
        CMA: 'cma',
        LMR: 'lmr',
        Traza: 'trazaCultivo',
      };
      Object.entries(mapping).forEach(([storeKey, formKey]) => {
        this.formData[formKey] = this.store[storeKey];
      });
      this.formData.idFamiliaTM = this.normalizeSelectionId(
        this.store.idFamiliaTM
      );
      this.formData.IdTipoMuestra = this.normalizeSelectionId(
        this.store.IdTipoMuestra
      );
      this.formData.IdSubTipoMuestra = this.normalizeSelectionId(
        this.store.IdSubTipoMuestra
      );
      this.formData.FincaLiteral =
        this.store.FincaLiteral ||
        this.store.fincaLiteral ||
        this.store.Finca ||
        null;
      this.formData.ParcelaLiteral =
        this.store.ParcelaLiteral ||
        this.store.parcelaLiteral ||
        this.store.Parcela ||
        null;
      this.formData.idNivelPunto = this.normalizeSelectionId(
        this.store.IdNivelPunto ?? this.store.idNivelPunto
      );
      this.formData.NivelPuntoCoordLiteral =
        this.store.NivelPuntoCoordLiteral ||
        this.store.nivelPuntoCoordLiteral ||
        null;
    }
    await this.fetchFarmsAndParcels();
    this.farmsLoaded = true;
    await this.fetchFamilies(this.store.CodPresupuesto);
    await this.handleFamilyChange(this.formData.idFamiliaTM, {
      preserveValues: true,
    });
    this.restoreSelectedSampleType();
    await this.handleSampleTypeChange(this.formData.IdTipoMuestra, {
      preserveValues: true,
    });
    this.restoreSelectedSubSampleType();
    this.handleSubSampleTypeChange(this.formData.IdSubTipoMuestra);
    this.restoreSelectedArticle();
    await this.handleArticleChange(this.formData.CodArticulo, {
      preserveValues: true,
    });
    const currentIdFinca = this.normalizeSelectionId(
      this.store.IdFinca ?? this.store.idFinca
    );
    let currentIdParcela = this.normalizeSelectionId(
      this.store.IdParcela ?? this.store.idParcela
    );
    const currentFarm =
      currentIdFinca != null
        ? this.findFarmById(currentIdFinca)
        : null;
    if (
      currentIdParcela == null &&
      currentFarm?.Parcelas?.length &&
      this.formData.ParcelaLiteral
    ) {
      const normalizedStoredParcelaLiteral = this.normalizeText(
        this.formData.ParcelaLiteral
      );
      const parcelMatchedByLiteral = currentFarm.Parcelas.find(
        (item) =>
          this.normalizeText(item?.Parcela) ===
          normalizedStoredParcelaLiteral
      );
      currentIdParcela = this.normalizeSelectionId(
        parcelMatchedByLiteral?.idParcela
      );
    }
    const currentParcel =
      currentIdParcela != null && currentFarm?.Parcelas?.length
        ? currentFarm.Parcelas.find(
            (item) =>
              this.normalizeSelectionId(item.idParcela) ===
              currentIdParcela
          )
        : null;
    const normalizedStoredFincaLiteral = this.normalizeText(
      this.formData.FincaLiteral
    );
    const normalizedStoredParcelaLiteral = this.normalizeText(
      this.formData.ParcelaLiteral
    );
    const normalizedFarmName = this.normalizeText(currentFarm?.Finca);
    const normalizedParcelName = this.normalizeText(
      currentParcel?.Parcela
    );
    const hasCustomManualLocation =
      (normalizedStoredFincaLiteral &&
        normalizedFarmName &&
        normalizedStoredFincaLiteral !== normalizedFarmName) ||
      (normalizedStoredParcelaLiteral &&
        normalizedParcelName &&
        normalizedStoredParcelaLiteral !== normalizedParcelName);
    this.formData.cma = Boolean(this.store.CMA);
    this.formData.lmr = Boolean(this.store.LMR);
    this.formData.trazaCultivo = Boolean(this.store.Traza);
    this.formData.organicFarming = Boolean(
      this.store.ProduccionOrganica || this.store.CultivoOrganico
    );

    this.traceCultiveVisible = this.checkLmr;
    if (
      currentIdFinca != null &&
      currentIdParcela != null &&
      !hasCustomManualLocation
    ) {
      this.formData.automaticSamplingPoint = true;
      this.typebox = 'dxSelectBox';
      this.formData.Parcelas = currentIdFinca;
      this.formData.Parcela = currentIdParcela;
    } else {
      this.formData.automaticSamplingPoint = false;
      this.parcelaDisabled = false;
      this.formData.Parcelas = this.formData.FincaLiteral;
      this.formData.Parcela = this.formData.ParcelaLiteral;
    }
    this.isHydratingSelectors = false;
    this.syncFarmAndParcelState();
    if (this.store.CMA && this.store.idLegislacion) {
      this.checkCma = true;
      await this.fetchLegislations();
      this.formData.idLegislacion = this.store.idLegislacion;
      this.formData.Legislacion = this.store.idLegislacion;
      this.legislationVisible = true;
      this.traceCultiveVisible = false;
    }
    if (this.store.Traza === true) {
      this.traceValue = true;
    }
    if (
      this.store.ProduccionOrganica === true ||
      this.store.CultivoOrganico === true
    ) {
      this.cultiveValue = true;
    }
    if (this.store.IdTipoMuestra === 77) {
      this.chlorineVisible = true;
    } else {
      this.chlorineVisible = false;
    }
    this.syncFarmAndParcelState();
    await this.$nextTick();
    this.updateParcelasEditorType(
      this.formData.automaticSamplingPoint
    );
    this.isFormReady = true;
    await this.$nextTick();
    this.rehydrateInitialComboSelections();
  },
  mounted() {
    this.updateParcelasEditorType(
      this.formData.automaticSamplingPoint
    );
  },
  methods: {
    buildAnalysisDisplayText(item, fallbackText = '') {
      if (!item) return fallbackText || '';
      if (item.AtDescrip) return item.AtDescrip;

      const article = item.Articulo || item.CodAnalisisTipo || '';
      const description = item.DescripcionAT || '';
      const subFamily = this.getTranslatedSubFamilyLabel(item) || '';
      const parts = [article, description, subFamily].filter(
        (part) => typeof part === 'string' && part.trim() !== ''
      );

      return parts.length ? parts.join(' - ') : fallbackText || '';
    },
    normalizeSelectionId(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }
      const normalizedValue = Number(value);
      return Number.isNaN(normalizedValue) ? value : normalizedValue;
    },
    normalizeText(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase();
    },
    normalizeDateOnly(value) {
      if (!value) return null;

      const parsedDate = new Date(value);
      if (Number.isNaN(parsedDate.getTime())) {
        return null;
      }

      return new Date(
        parsedDate.getFullYear(),
        parsedDate.getMonth(),
        parsedDate.getDate()
      );
    },
    findFarmById(idFinca) {
      return this.normalizedFarms.find(
        (item) => this.normalizeSelectionId(item.idFinca) === idFinca
      );
    },
    findParcelById(idParcela) {
      return this.filteredParcels.find(
        (item) =>
          this.normalizeSelectionId(item.idParcela) === idParcela
      );
    },
    async fetchFamilies(offer) {
      try {
        await this.fetchDetallesPresupuestos(offer);
        await this.fetchFamiliesByHierarchy();

        if (
          this.detallesPresupuestos.length > 0 &&
          this.families.length > 0
        ) {
          this.offersFamiliesFiltered = [
            ...new Set(
              this.detallesPresupuestos.map((item) => item.IdFamilia)
            ),
          ];
          this.familiesFiltered = this.families.filter((item) =>
            this.offersFamiliesFiltered.includes(item.idFamiliaTM)
          );
          this.familiDisabled = false;
        }
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      }
    },
    async handleBudgetChange(codPresupuesto, options = {}) {
      const {
        preserveValues = false,
        previousBudgetCode = null,
        forcedSelections = null,
      } = options;
      const previousSelections = forcedSelections || {
        idFamiliaTM: this.formData.idFamiliaTM,
        FamiliaTM: this.formData.FamiliaTM,
        IdTipoMuestra: this.formData.IdTipoMuestra,
        Descripcion: this.formData.Descripcion,
        IdSubTipoMuestra: this.formData.IdSubTipoMuestra,
        SubTipoMuestra: this.formData.SubTipoMuestra,
        CodArticulo: this.formData.CodArticulo,
        Articulo: this.formData.Articulo,
      };
      this.isHydratingSelectors = true;
      this.isLoadingBudgetOptions = Boolean(codPresupuesto);
      try {
        if (codPresupuesto) {
          await this.fetchFamilies(codPresupuesto);
        } else {
          this.familiDisabled = true;
        }

        const familyStillAvailable = this.familiesFiltered.some(
          (item) =>
            this.normalizeSelectionId(item?.idFamiliaTM) ===
            this.normalizeSelectionId(previousSelections.idFamiliaTM)
        );

        if (
          previousSelections.idFamiliaTM != null &&
          familyStillAvailable
        ) {
          this.formData.idFamiliaTM = this.normalizeSelectionId(
            previousSelections.idFamiliaTM
          );
          this.formData.FamiliaTM =
            previousSelections.FamiliaTM || this.formData.FamiliaTM;

          await this.handleFamilyChange(this.formData.idFamiliaTM, {
            preserveValues: true,
          });

          this.formData.IdTipoMuestra = this.normalizeSelectionId(
            previousSelections.IdTipoMuestra
          );
          this.formData.Descripcion =
            previousSelections.Descripcion || null;
          this.restoreSelectedSampleType();

          await this.handleSampleTypeChange(
            this.formData.IdTipoMuestra,
            {
              preserveValues: true,
            }
          );

          this.formData.IdSubTipoMuestra = this.normalizeSelectionId(
            previousSelections.IdSubTipoMuestra
          );
          this.formData.SubTipoMuestra =
            previousSelections.SubTipoMuestra || null;
          this.restoreSelectedSubSampleType();
          this.handleSubSampleTypeChange(
            this.formData.IdSubTipoMuestra
          );

          this.formData.CodArticulo =
            previousSelections.CodArticulo || null;
          this.formData.Articulo =
            previousSelections.Articulo || null;
          this.restoreSelectedArticle();
          await this.handleArticleChange(this.formData.CodArticulo, {
            preserveValues: true,
          });
          return;
        }

        if (
          previousSelections.idFamiliaTM != null &&
          !familyStillAvailable &&
          this.isShippingDateInFuture
        ) {
          this.$notifyDX(
            {
              message: this.$t(
                'samplesRegister.selectedFamilyNotAvailableForBudget'
              ),
              width: 650,
            },
            'error',
            NOTIFY_TIME_LONG
          );
        }

        if (
          previousSelections.idFamiliaTM != null &&
          !familyStillAvailable &&
          this.isFamilyLockedByShippingDate
        ) {
          this.$notifyDX(
            {
              message: this.$t(
                'samplesRegister.selectedFamilyNotAvailableForTaggedSampleBudget'
              ),
              width: 650,
            },
            'error',
            NOTIFY_TIME_LONG
          );

          this.isRevertingBudgetSelection = true;
          this.revertingBudgetContext = {
            previousBudgetCode,
            previousSelections: {
              ...previousSelections,
            },
          };
          this.formData.CodPresupuesto =
            previousBudgetCode || this.store?.CodPresupuesto || null;
          return;
        }

        if (!preserveValues) {
          this.formData.idFamiliaTM = null;
          this.formData.FamiliaTM = null;
          this.formData.IdTipoMuestra = null;
          this.formData.Descripcion = null;
          this.formData.IdSubTipoMuestra = null;
          this.formData.SubTipoMuestra = null;
          this.formData.CodArticulo = null;
          this.formData.Articulo = null;
          this.formData.CodLinea = null;
          this.formData.IdAnalisisTipo = null;
          this.formData.idPresupuestoATNoS = null;
          this.formData.IdPresupuestoATNoS = null;
          this.formData.idSubFamiliaTM = null;
          this.formData.PrecioAT = null;
          this.formData.cma = null;
          this.formData.lmr = null;
          this.formData.Legislacion = null;
          this.formData.idLegislacion = null;
          this.sampletypesUi = [];
          this.subSampleType = [];
          this.analysisType = [];
          this.idSubFamiliaTiposMuestras = null;
          this.subSampleTypeVisible = true;
          this.analysisTypeDisabled = true;
          this.sampleTypesDisabled = true;
        }
      } finally {
        this.isLoadingBudgetOptions = false;
        this.isHydratingSelectors = false;
      }
    },
    async fetchSubFamiliesFiltered(IdFamilia) {
      try {
        this.subFamiliesFiltered = [
          ...new Set(
            (this.detallesPresupuestos || [])
              .filter(
                (item) =>
                  this.normalizeSelectionId(item?.IdFamilia) ===
                  this.normalizeSelectionId(IdFamilia)
              )
              .map((item) =>
                this.normalizeSelectionId(
                  item?.IdSubFamilia ?? item?.IdSubFamiliaTM
                )
              )
              .filter((value) => value !== null)
          ),
        ];
        await this.fetchSamplesTypes({
          IdFamilia,
          subfamilias: this.subFamiliesFiltered,
        });
        this.sampleTypesDisabled = false;
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      }
    },
    async analysisTypeFiltered(idFamilia, idSubFamilia) {
      const normalizedFamilyId = this.normalizeSelectionId(idFamilia);
      const normalizedSubFamilyId =
        this.normalizeSelectionId(idSubFamilia);

      if (
        normalizedFamilyId === null ||
        normalizedSubFamilyId === null
      ) {
        this.analysisType = [];
        return [];
      }

      const matchingLines = (this.detallesPresupuestos || []).filter(
        (item) =>
          this.normalizeSelectionId(item?.IdFamilia) ===
            normalizedFamilyId &&
          this.normalizeSelectionId(
            item?.IdSubFamilia ?? item?.IdSubFamiliaTM
          ) === normalizedSubFamilyId
      );

      if (!matchingLines.length) {
        this.analysisType = [];
        return [];
      }

      this.analysisType = await this.analysisTypeDescrForLine(
        matchingLines
      );
      return this.analysisType;
    },
    getTranslatedSubFamilyLabel(item) {
      const familyId = Number(item?.IdFamilia);
      const subFamilyId = Number(
        item?.IdSubFamilia ?? item?.IdSubFamiliaTM
      );
      const family = (this.families || []).find(
        (entry) => Number(entry?.idFamiliaTM) === familyId
      );
      const subFamily = family?.SubFamiliasTM?.find(
        (entry) => Number(entry?.idSubFamiliaTM) === subFamilyId
      );

      return subFamily?.SubFamiliaTM ?? item?.SubFamiliaTM ?? '';
    },
    async analysisTypeDescrForLine(offersLines) {
      const codigoClientePresupuesto =
        this.detallesPresupuestos.codCliente;
      const [referenceLine] = offersLines || [];

      if (!referenceLine) {
        return [];
      }

      let listadoAnalisisTipo = [];

      try {
        await this.fetchAnalisisTipo({
          codPlanta:
            referenceLine.CodPlantaCentroProduccionSeleccionada || '',
          idFamiliaTM: referenceLine.IdFamilia,
          idSubFamiliaTM:
            referenceLine.IdSubFamilia ?? referenceLine.IdSubFamiliaTM,
          codCliente: codigoClientePresupuesto,
          codIdioma: null,
        });
        listadoAnalisisTipo = this.analisisTipoDescrip || [];
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
        return [];
      }

      return [...offersLines].map((item) => {
        let at = null;
        if (
          this.normalizeSelectionId(item?.IdSubFamiliaTM) === 63 ||
          this.normalizeSelectionId(item?.IdSubFamilia) === 63
        ) {
          at = listadoAnalisisTipo.find(
            (analysis) => analysis.AnalisisTipo === item.Articulo
          );
        } else {
          const idAnalisisTipo = String(item.CodArticulo || '').slice(
            1
          );
          at = listadoAnalisisTipo.find(
            (analysis) =>
              analysis.IdAnalisisTipo?.toString() === idAnalisisTipo
          );
        }

        const subFamiliaDescripcion =
          this.getTranslatedSubFamilyLabel(item);
        const analysisDescription =
          at?.DescripcionAT ?? item?.DescripcionAT ?? '';

        return {
          ...item,
          CodAnalisisTipo: at?.CodAnalisisTipo ?? item?.CodAnalisisTipo,
          DescripcionAT:
            at?.IdSubFamiliaTM === 63
              ? at?.CodAnalisisTipo
              : analysisDescription,
          AtDescrip: `${item.Articulo} - ${analysisDescription} - ${subFamiliaDescripcion}`,
        };
      });
    },
    async handleFamilyChange(
      idFamilia,
      { preserveValues = false } = {}
    ) {
      this.isLoadingSampleTypes = Boolean(idFamilia);
      if (!preserveValues) {
        this.formData.IdTipoMuestra = null;
        this.formData.IdSubTipoMuestra = null;
        this.formData.CodArticulo = null;
        this.formData.Descripcion = null;
        this.formData.SubTipoMuestra = null;
        this.formData.Articulo = null;
        // A family change can invalidate the previously selected sampling
        // point. Clear it to avoid sending stale ids from the prior sample
        // context, which can cause backend modification errors.
        this.formData.automaticSamplingPoint = false;
        this.filteredParcels = [];
        this.parcelaDisabled = false;
        this.formData.Parcelas = null;
        this.formData.Parcela = null;
        this.formData.FincaLiteral = null;
        this.formData.ParcelaLiteral = null;
      }

      this.subSampleType = [];
      this.subSampleTypeVisible = true;
      this.idSubFamiliaTiposMuestras = null;
      this.analysisTypeDisabled = true;
      this.sampleTypesDisabled = true;
      this.sampletypesUi = [];

      try {
        if (idFamilia) {
          await this.fetchSubFamiliesFiltered(idFamilia);
          this.sampletypesUi = Array.isArray(this.sampletypes)
            ? [...this.sampletypes]
            : [];

          const selectedFamily = this.familiesFiltered.find(
            (item) =>
              this.normalizeSelectionId(item.idFamiliaTM) ===
              this.normalizeSelectionId(idFamilia)
          );
          this.formData.FamiliaTM =
            selectedFamily?.FamiliaTM || this.formData.FamiliaTM;
        } else {
          this.sampleTypesDisabled = true;
        }
      } finally {
        this.isLoadingSampleTypes = false;
      }
    },
    async handleSampleTypeChange(
      idTipoMuestra,
      { preserveValues = false } = {}
    ) {
      const selectedType = this.normalizedSampletypesUi.find(
        (item) =>
          this.normalizeSelectionId(item.idTipoMuestra) ===
          this.normalizeSelectionId(idTipoMuestra)
      );

      if (selectedType) {
        if (!preserveValues) {
          this.formData.CodArticulo = null;
          this.formData.Articulo = null;
          this.formData.CodLinea = null;
          this.formData.idSubFamiliaTM = null;
        }
        this.formData.Descripcion = selectedType.Descripcion;
        this.formData.IdTipoMuestra = this.normalizeSelectionId(
          selectedType.idTipoMuestra
        );
        this.analysisTypeDisabled = false;
        this.idSubFamiliaTiposMuestras = Number(
          selectedType.idSubFamiliaTM ??
            selectedType.id_sub_familia
        );
        if (
          selectedType.SubTiposMuestras &&
          selectedType.SubTiposMuestras.length > 0
        ) {
          this.subSampleType = selectedType.SubTiposMuestras;
          this.subSampleTypeVisible = false;
        } else {
          this.subSampleType = [];
          this.subSampleTypeVisible = true;
          if (!preserveValues) {
            this.formData.IdSubTipoMuestra = null;
            this.formData.SubTipoMuestra = null;
          }
        }
        await this.analysisTypeFiltered(
          this.normalizeSelectionId(this.formData.idFamiliaTM),
          this.idSubFamiliaTiposMuestras
        );
      } else {
        this.subSampleType = [];
        this.subSampleTypeVisible = true;
        this.analysisTypeDisabled = true;
        this.idSubFamiliaTiposMuestras = null;
        this.analysisType = [];
        if (!preserveValues) {
          this.formData.IdSubTipoMuestra = null;
          this.formData.SubTipoMuestra = null;
          this.formData.CodArticulo = null;
          this.formData.Articulo = null;
        }
      }

      this.chlorineVisible =
        this.normalizeSelectionId(idTipoMuestra) === 77;
    },
    handleSubSampleTypeChange(idSubTipoMuestra) {
      const selectedSubType = this.normalizedSubSampleType.find(
        (item) =>
          this.normalizeSelectionId(item.idSubTipoMuestra) ===
          this.normalizeSelectionId(idSubTipoMuestra)
      );
      this.formData.SubTipoMuestra =
        selectedSubType?.Descripcion || null;
    },
    restoreSelectedSampleType() {
      const currentTypeText = this.normalizeText(
        this.formData.Descripcion
      );
      const selectedType = this.normalizedSampletypesUi.find(
        (item) =>
          this.normalizeSelectionId(item.idTipoMuestra) ===
            this.normalizeSelectionId(this.formData.IdTipoMuestra) ||
          this.normalizeText(item.Descripcion) === currentTypeText
      );

      if (selectedType) {
        this.formData.IdTipoMuestra = this.normalizeSelectionId(
          selectedType.idTipoMuestra
        );
        this.formData.Descripcion = selectedType.Descripcion;
      }
    },
    restoreSelectedSubSampleType() {
      const currentSubTypeText = this.normalizeText(
        this.formData.SubTipoMuestra
      );
      const selectedSubType = this.normalizedSubSampleType.find(
        (item) =>
          this.normalizeSelectionId(item.idSubTipoMuestra) ===
            this.normalizeSelectionId(
              this.formData.IdSubTipoMuestra
            ) ||
          this.normalizeText(item.Descripcion) === currentSubTypeText
      );

      if (selectedSubType) {
        this.formData.IdSubTipoMuestra = this.normalizeSelectionId(
          selectedSubType.idSubTipoMuestra
        );
        this.formData.SubTipoMuestra = selectedSubType.Descripcion;
      }
    },
    restoreSelectedArticle() {
      const currentArticleText = this.normalizeText(
        this.formData.Articulo
      );
      const selectedArticleByCode = this.articlesBySubFamilia.find(
        (item) => item.CodArticulo === this.formData.CodArticulo
      );
      const selectedArticleByAnalysisCode =
        this.articlesBySubFamilia.find(
          (item) =>
            this.normalizeText(item.CodAnalisisTipo) ===
            currentArticleText
        );
      const selectedArticleByExactText =
        this.articlesBySubFamilia.find((item) => {
          const normalizedAtDescrip = this.normalizeText(
            item.AtDescrip
          );
          const normalizedArticulo = this.normalizeText(
            item.Articulo
          );
          const normalizedDescripcionAt = this.normalizeText(
            item.DescripcionAT
          );

          return (
            normalizedArticulo === currentArticleText ||
            normalizedAtDescrip === currentArticleText ||
            normalizedDescripcionAt === currentArticleText
          );
        });
      const selectedArticle =
        selectedArticleByCode ||
        selectedArticleByAnalysisCode ||
        selectedArticleByExactText ||
        null;

      if (selectedArticle) {
        this.formData.CodArticulo = selectedArticle.CodArticulo;
        this.formData.IdAnalisisTipo =
          selectedArticle.IdAnalisisTipo ??
          this.formData.IdAnalisisTipo;
        this.formData.idPresupuestoATNoS =
          selectedArticle.idPresupuestoATNoS ??
          selectedArticle.IdPresupuestoATNoS ??
          this.formData.idPresupuestoATNoS;
        this.formData.IdPresupuestoATNoS =
          selectedArticle.IdPresupuestoATNoS ??
          selectedArticle.idPresupuestoATNoS ??
          this.formData.IdPresupuestoATNoS;
        this.formData.Articulo =
          selectedArticle.AtDescrip ||
          selectedArticle.CodAnalisisTipo ||
          selectedArticle.Articulo ||
          this.formData.Articulo;
      }
    },
    rehydrateInitialComboSelections() {
      this.restoreSelectedSampleType();
      this.restoreSelectedSubSampleType();
      this.restoreSelectedArticle();

      const storeIdFinca = this.normalizeSelectionId(
        this.store?.IdFinca ?? this.store?.idFinca
      );
      const storeIdParcela = this.normalizeSelectionId(
        this.store?.IdParcela ?? this.store?.idParcela
      );
      const storeIdNivelPunto = this.normalizeSelectionId(
        this.store?.IdNivelPunto ?? this.store?.idNivelPunto
      );

      if (this.formData.automaticSamplingPoint) {
        if (!this.formData.Parcelas && storeIdFinca != null) {
          this.formData.Parcelas = storeIdFinca;
        }

        if (!this.formData.Parcela && storeIdParcela != null) {
          this.formData.Parcela = storeIdParcela;
        }

        if (
          !this.formData.idNivelPunto &&
          storeIdNivelPunto != null
        ) {
          this.formData.idNivelPunto = storeIdNivelPunto;
        }

        if (!this.formData.Parcelas && this.formData.FincaLiteral) {
          const matchedFarm = this.normalizedFarms.find(
            (item) =>
              this.normalizeText(item?.Finca) ===
              this.normalizeText(this.formData.FincaLiteral)
          );
          if (matchedFarm) {
            this.formData.Parcelas = this.normalizeSelectionId(
              matchedFarm.idFinca
            );
            this.filteredParcels = Array.isArray(matchedFarm.Parcelas)
              ? [...matchedFarm.Parcelas]
              : [];
          }
        }

        if (
          this.formData.Parcelas &&
          !this.formData.Parcela &&
          this.formData.ParcelaLiteral
        ) {
          const matchedParcel = this.filteredParcels.find(
            (item) =>
              this.normalizeText(item?.Parcela) ===
              this.normalizeText(this.formData.ParcelaLiteral)
          );
          if (matchedParcel) {
            this.formData.Parcela = this.normalizeSelectionId(
              matchedParcel.idParcela
            );
          }
        }

        if (this.formData.Parcela) {
          const selectedParcel = this.findParcelById(
            this.normalizeSelectionId(this.formData.Parcela)
          );
          this.filteredLevelPoints = Array.isArray(
            selectedParcel?.nivelPuntos
          )
            ? [...selectedParcel.nivelPuntos]
            : [];

          if (
            !this.formData.idNivelPunto &&
            this.formData.NivelPuntoCoordLiteral
          ) {
            const matchedPoint = this.filteredLevelPoints.find(
              (item) =>
                this.getLevelPointOptionText(item) ===
                this.formData.NivelPuntoCoordLiteral
            );
            if (matchedPoint) {
              this.formData.idNivelPunto = this.normalizeSelectionId(
                matchedPoint.idNivelPunto
              );
            }
          }
        }
      }

      const formInstance = this.$refs.splRegisterForm?.instance;
      if (formInstance) {
        this.isRehydratingSamplingPoint = true;
        formInstance.updateData(
          'IdTipoMuestra',
          this.formData.IdTipoMuestra
        );
        formInstance.updateData(
          'IdSubTipoMuestra',
          this.formData.IdSubTipoMuestra
        );
        formInstance.updateData(
          'CodArticulo',
          this.formData.CodArticulo
        );
        formInstance.updateData('Parcelas', this.formData.Parcelas);
        formInstance.updateData('Parcela', this.formData.Parcela);
        formInstance.updateData(
          'idNivelPunto',
          this.formData.idNivelPunto
        );
        formInstance
          .getEditor('Parcela')
          ?.option('dataSource', this.filteredParcels);
        formInstance
          .getEditor('idNivelPunto')
          ?.option('dataSource', this.filteredLevelPoints);
        this.$nextTick(() => {
          formInstance.updateData('Parcela', this.formData.Parcela);
          formInstance.updateData(
            'idNivelPunto',
            this.formData.idNivelPunto
          );
          formInstance
            .getEditor('Parcela')
            ?.option('value', this.formData.Parcela);
          formInstance
            .getEditor('idNivelPunto')
            ?.option('value', this.formData.idNivelPunto);
          this.isRehydratingSamplingPoint = false;
        });
      }
    },
    async handleArticleChange(
      codArticulo,
      { preserveValues = false } = {}
    ) {
      const cma = this.analysisType.find(
        (item) =>
          item.TipoServicioCma !== null &&
          item.CodArticulo === codArticulo
      );
      const lmr = this.analysisType.find(
        (item) =>
          item.TipoServicioLmr !== null &&
          item.CodArticulo === codArticulo
      );
      const articulo = this.analysisType.find(
        (item) => item.CodArticulo === codArticulo
      );

      if (articulo) {
        this.formData.Articulo =
          articulo.AtDescrip || articulo.Articulo || null;
        this.formData.CodArticulo = articulo.CodArticulo;
        this.formData.CodLinea = articulo.CodLinea;
        this.formData.IdAnalisisTipo =
          articulo.IdAnalisisTipo ?? null;
        this.formData.idPresupuestoATNoS =
          articulo.idPresupuestoATNoS ??
          articulo.IdPresupuestoATNoS ??
          null;
        this.formData.IdPresupuestoATNoS =
          articulo.IdPresupuestoATNoS ??
          articulo.idPresupuestoATNoS ??
          null;
        this.formData.idSubFamiliaTM =
          articulo.IdSubFamilia ?? articulo.IdSubFamiliaTM;
        this.formData.PrecioAT = this.getArticlePrice(articulo);
      } else if (!preserveValues) {
        this.formData.Articulo = null;
        this.formData.CodLinea = null;
        this.formData.IdAnalisisTipo = null;
        this.formData.idPresupuestoATNoS = null;
        this.formData.IdPresupuestoATNoS = null;
        this.formData.idSubFamiliaTM = null;
        this.formData.PrecioAT = null;
      }

      switch (true) {
        case cma !== undefined:
          this.checkCma = true;
          this.checkLmr = false;
          this.traceCultiveVisible = false;
          this.formData.lmr = false;
          this.formData.trazaCultivo = false;
          this.formData.organicFarming = false;
          break;
        case lmr !== undefined:
          this.checkLmr = true;
          this.checkCma = false;
          this.traceCultiveVisible = true;
          this.formData.cma = false;
          break;
        default:
          this.checkLmr = false;
          this.checkCma = false;
          this.traceCultiveVisible = false;
          this.formData.cma = false;
          this.formData.lmr = false;
          this.formData.trazaCultivo = false;
          this.formData.organicFarming = false;
      }

      const rawLegislationId = cma?.TipoServicioCma?.IdLegislacion;
      const hasValidLegislationId = Number(rawLegislationId) > 0;

      if (hasValidLegislationId) {
        await this.fetchLegislations();
        this.formData.idLegislacion = Number(rawLegislationId);
        this.formData.Legislacion = Number(rawLegislationId);
        this.legislationVisible = true;
      } else if (!preserveValues) {
        this.formData.idLegislacion = null;
        this.formData.Legislacion = null;
        this.legislationVisible = false;
      }
    },
    getArticlePrice(articulo) {
      const precioBruto = Number(articulo?.PrecioBruto);
      const descuento = Number(articulo?.Descuento || 0);

      if (Number.isNaN(precioBruto)) {
        return articulo?.PrecioAT ?? null;
      }

      return precioBruto - (precioBruto * descuento) / 100;
    },
    formatPrice(value) {
      if (value === null || value === undefined || value === '') {
        return '';
      }

      const normalizedValue = Number(value);
      if (Number.isNaN(normalizedValue)) {
        return String(value);
      }

      return this.formatAmount(
        normalizedValue,
        helpers.resolveCurrency({
          conversionX3: this.store?.ConversionX3,
          clientCurrency: this.contactInfo?.currency,
          m: this.store?.M,
          moneda: this.store?.Moneda,
          fallback: 'EUR',
        })
      );
    },
    formatAmount(amount, currency) {
      if (amount === null || amount === undefined || amount === '') {
        return '';
      }

      // Algunas respuestas traen importes y divisas con formato visual/ERP
      // en lugar de valores ya normalizados; saneamos ambos antes de usar
      // Intl para evitar errores al renderizar.
      const parsedAmount = Number(
        typeof amount === 'string'
          ? amount.replace(',', '.').replace(/[^\d.-]/g, '')
          : amount
      );

      if (Number.isNaN(parsedAmount)) {
        return String(amount);
      }

      return helpers.formatCurrency(parsedAmount, currency, 'es');
    },
    getLevelPointOptionText(item) {
      if (!item) return '';
      const label =
        item?.NivelPunto ||
        item?.nivelPunto ||
        item?.descripcion ||
        item?.Descripcion ||
        this.$t('point');
      return item?.GPSZ ? `${label} - ${item.GPSZ}` : label;
    },
    getLevelPointPlaceholder() {
      if (!this.formData.automaticSamplingPoint) {
        return this.$t('notApplicable');
      }
      if (this.formData.Parcela == null) {
        return '';
      }
      if (!this.filteredLevelPoints.length) {
        return this.$t('notApplicable');
      }
      return '';
    },
    handleLevelPointChange(e) {
      const selectedPoint = this.filteredLevelPoints.find(
        (item) =>
          this.normalizeSelectionId(item?.idNivelPunto) ===
          this.normalizeSelectionId(e?.value)
      );
      this.formData.idNivelPunto = e?.value ?? null;
      this.formData.NivelPuntoCoordLiteral = selectedPoint
        ? this.getLevelPointOptionText(selectedPoint)
        : null;
    },
    handleLevelPointLiteralChange(e) {
      if (this.formData.automaticSamplingPoint) return;
      this.formData.NivelPuntoCoordLiteral = e?.value ?? null;
    },
    syncFarmAndParcelState() {
      if (!this.formData.automaticSamplingPoint) {
        this.filteredLevelPoints = [];
        this.formData.idNivelPunto = null;
        if (
          this.formData.Parcelas !== null &&
          this.formData.Parcelas !== undefined
        ) {
          this.formData.FincaLiteral = this.formData.Parcelas || null;
        }
        if (
          this.formData.Parcela !== null &&
          this.formData.Parcela !== undefined
        ) {
          this.formData.ParcelaLiteral =
            this.formData.Parcela || null;
        }
        this.parcelaDisabled = false;
        return;
      }

      if (!this.formData.Parcelas) {
        this.filteredParcels = [];
        this.filteredLevelPoints = [];
        this.formData.idNivelPunto = null;
        this.parcelaDisabled = true;
        return;
      }

      const normalizedIdFinca = this.normalizeSelectionId(
        this.formData.Parcelas
      );
      const farm = this.findFarmById(normalizedIdFinca);
      this.filteredParcels = farm?.Parcelas ? [...farm.Parcelas] : [];
      this.parcelaDisabled = false;
      this.formData.FincaLiteral =
        farm?.Finca || this.formData.FincaLiteral || null;

      if (this.formData.Parcela) {
        const normalizedIdParcela = this.normalizeSelectionId(
          this.formData.Parcela
        );
        const parcela = this.findParcelById(normalizedIdParcela);
        this.filteredLevelPoints = Array.isArray(parcela?.nivelPuntos)
          ? [...parcela.nivelPuntos]
          : [];
        this.formData.ParcelaLiteral =
          parcela?.Parcela || this.formData.ParcelaLiteral || null;
        if (this.formData.idNivelPunto != null) {
          const selectedPoint = this.filteredLevelPoints.find(
            (item) =>
              this.normalizeSelectionId(item?.idNivelPunto) ===
              this.normalizeSelectionId(this.formData.idNivelPunto)
          );
          this.formData.NivelPuntoCoordLiteral = selectedPoint
            ? this.getLevelPointOptionText(selectedPoint)
            : this.formData.NivelPuntoCoordLiteral || null;
        }
      } else {
        this.filteredLevelPoints = [];
      }
    },
    updateParcelasEditorType(useSelect) {
      const formInstance = this.$refs.splRegisterForm?.instance;
      if (!formInstance) {
        return;
      }
      // The auto/manual mode is handled in template with v-if/v-else.
      // Here we only refresh current editor data after the branch swap.
      formInstance.updateData('Parcelas', this.formData.Parcelas);
      formInstance.updateData('Parcela', this.formData.Parcela);
      formInstance.updateData(
        'FincaLiteral',
        this.formData.FincaLiteral
      );
      formInstance.updateData(
        'ParcelaLiteral',
        this.formData.ParcelaLiteral
      );
      formInstance.updateData(
        'idNivelPunto',
        this.formData.idNivelPunto
      );
      formInstance.updateData(
        'NivelPuntoCoordLiteral',
        this.formData.NivelPuntoCoordLiteral
      );
      formInstance
        .getEditor('Parcela')
        ?.option('dataSource', this.filteredParcels);
      formInstance
        .getEditor('idNivelPunto')
        ?.option('dataSource', this.filteredLevelPoints);
      formInstance
        .getEditor('NivelPuntoCoordLiteral')
        ?.option('value', this.formData.NivelPuntoCoordLiteral);
    },
    ...mapActions('Offers', [
      'fetchPresupuestos',
      'fetchDetallesPresupuestos',
      'fetchAnalisisTipo',
    ]),
    ...mapActions('samplesRegisterModule', [
      'fetchSamplesTypes',
      'fetchFamiliesByHierarchy',
      'fetchLegislations',
      'fetchFarmsAndParcels',
    ]),
  },
};
</script>
<style scoped>
.form-loading-state {
  min-height: 420px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-container {
  position: relative;
}

.form-loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.55);
  z-index: 10;
}

.preloader-card {
  min-width: 190px;
}

.sample-summary-row {
  display: grid;
  grid-template-columns: minmax(180px, 1fr) minmax(260px, 2fr) minmax(
      100px,
      120px
    );
  align-items: center;
  gap: 16px;
  margin-top: 20px;
  padding: 14px 24px;
  background: #f7f7f8;
  border-radius: 10px;
  color: #17375e;
}

.sample-summary-code,
.sample-summary-price {
  font-weight: 600;
}

.sample-summary-analysis {
  text-align: center;
}

.sample-summary-price {
  text-align: right;
}

@media (max-width: 768px) {
  .sample-summary-row {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .sample-summary-analysis,
  .sample-summary-price {
    text-align: left;
  }
}
</style>
